import { useEffect, useId } from 'react';

// Track each dirty card independently so mounting/removing another card cannot
// accidentally unlock the rest of the page.
export const useSettingEditing = (updated, setEditing) => {
  const id = useId();
  useEffect(() => {
    if (!updated) return;
    setEditing(id, true);
    return () => setEditing(id, false);
  }, [id, updated, setEditing]);
};

export const SettingField = ({ label, as: Control = 'input', children, ...props }) => {
  const id = useId();
  return <div className="setting-field">
    <label htmlFor={id}>{label}</label>
    <Control id={id} {...props}>{children}</Control>
  </div>;
};

export const SettingCard = ({ label, updated, disabled, onDelete, children }) => <fieldset
  className={`setting-card${updated ? ' is-editing' : ''}`}
  disabled={disabled}
  aria-label={label}
>
  <div className="setting-card-heading">
    <h3>{label}</h3>
    {updated && <span className="setting-edit-badge">수정 중</span>}
    {onDelete && <button type="button" className="setting-remove" aria-label={`${label} 삭제`} onClick={onDelete}>삭제</button>}
  </div>
  {children}
</fieldset>;

export const SettingActions = ({ onSave, onCancel }) => <div className="setting-actions">
  <p>변경한 내용을 저장해 주세요.</p>
  <div>
    <button type="button" className="book-secondary-button" onClick={onCancel}>취소</button>
    <button type="button" className="book-primary-button" onClick={onSave}>저장하기 <span aria-hidden="true">✓</span></button>
  </div>
</div>;

export const SettingAddButton = ({ children, onClick, disabled }) => <button
  type="button" className="setting-add" onClick={onClick} disabled={disabled}
>
  <span aria-hidden="true">＋</span>{children}
</button>;
